import { render, staticRenderFns } from "./event-dateline.vue?vue&type=template&id=7c9d0605"
import script from "./event-dateline.vue?vue&type=script&lang=js"
export * from "./event-dateline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c9d0605')) {
      api.createRecord('7c9d0605', component.options)
    } else {
      api.reload('7c9d0605', component.options)
    }
    module.hot.accept("./event-dateline.vue?vue&type=template&id=7c9d0605", function () {
      api.rerender('7c9d0605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event-dateline.vue"
export default component.exports